// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".issue-image-gallery{\n    display: flex;\n    flex-direction: row;\n    margin-top: 5%;\n    justify-content: space-between;\n}\n\n.image{\n    height: 250px;\n    width: 250px\n}", ""]);
// Exports
module.exports = exports;
